'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.googleAnalyticsSend = exports.googleAnalyticsApi = exports.googleAnalyticsAvaliable = undefined;

var _lodash = require('lodash');

var _getClientConfig = require('../utils/getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

var _logger = require('../../client/utils/logger');

var _logger2 = _interopRequireDefault(_logger);

var _analyticsConstants = require('./analyticsConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useGoogleAnalytics = (0, _lodash.memoize)(function () {
    return (0, _getClientConfig2.default)().analytics.enabled && (0, _getClientConfig2.default)().analytics.googleTrackingId;
});
var googleAnalyticsAvaliable = exports.googleAnalyticsAvaliable = function googleAnalyticsAvaliable() {
    return !!window.ga;
};

var googleAnalyticsApi = exports.googleAnalyticsApi = function googleAnalyticsApi(action) {
    return function (data) {
        _logger2.default.info('Google Analytics:', action, data);

        if (!useGoogleAnalytics()) return;
        if (!googleAnalyticsAvaliable()) return _logger2.default.warn('Google Analytics not initialized yet');

        window.ga(action, data);
    };
};

var googleAnalyticsSend = exports.googleAnalyticsSend = googleAnalyticsApi(_analyticsConstants.GOOGLE_ANALYTICS_OPERATIONS.send);


//////////////////
// WEBPACK FOOTER
// ./src/client/analytics/googleAnalyticsService.js
// module id = 1664
// module chunks = 0